'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComparePricing = exports.ComparePricingUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _TrackDwell = require('decorators/TrackDwell/TrackDwell');

var _TrackDwell2 = _interopRequireDefault(_TrackDwell);

var _multitrack = require('helpers/multitrack');

var _currencyCodeToSymbol = require('constants/currency-code-to-symbol');

var _currencyCodeToSymbol2 = _interopRequireDefault(_currencyCodeToSymbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// We should eventually refactor currencyCodeToSymbol out of the code
var renderPrice = function renderPrice(number, currency) {
  return _react2.default.createElement(
    'div',
    { className: 'text--bold pricing-compare__number' },
    _react2.default.createElement(
      'span',
      { className: 'pricing-compare__symbol' },
      (0, _currencyCodeToSymbol2.default)(currency)
    ),
    _react2.default.createElement(
      'span',
      null,
      _react2.default.createElement(_reactIntl.FormattedNumber, {
        value: number,
        maximumFractionDigits: number % 1 === 0 ? 0 : 1
      })
    )
  );
};

var ComparePricingUnwrapped = exports.ComparePricingUnwrapped = function (_PureComponent) {
  (0, _inherits3.default)(ComparePricingUnwrapped, _PureComponent);

  function ComparePricingUnwrapped() {
    (0, _classCallCheck3.default)(this, ComparePricingUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (ComparePricingUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(ComparePricingUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(ComparePricingUnwrapped, [{
    key: 'onDwell',
    value: function onDwell() {
      (0, _multitrack.ga)('Compare Pricing Module', 'Viewed compare pricing module', null, 0, { nonInteraction: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          theirPrice = _props.theirPrice,
          currency = _props.currency,
          ourPrice = _props.ourPrice,
          backgroundColor = _props.backgroundColor;


      return _react2.default.createElement(
        'div',
        { className: 'bg--' + (backgroundColor || 'white') },
        _react2.default.createElement(
          'div',
          { className: 'pricing-compare' },
          _react2.default.createElement(
            'h2',
            { className: 'mv+' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'pricing-compare.title',
              defaultMessage: 'Compare our prices'
            })
          ),
          _react2.default.createElement(
            'p',
            { className: 'pricing-compare__subtitle mv' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'pricing-compare.subtitle',
              defaultMessage: 'ClassPass membership is the most affordable way to try studio fitness, and the easiest way to sample multiple studios.'
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'grid mt mb md-ph++' },
            _react2.default.createElement(
              'div',
              { className: 'grid__item 1/2 pricing-compare__price' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h1',
                  null,
                  renderPrice(theirPrice || 32, currency || 'USD')
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'text--bold text--lg mv-' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'pricing-compare.fitness-studio',
                    defaultMessage: 'Fitness studio'
                  })
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'color-text-light' },
                  _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'pricing-compare.fitness-studio-subtext',
                    defaultMessage: 'Average cost of class<br>through a single studio'
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'grid__item 1/2 pricing-compare__price' },
              _react2.default.createElement(
                'h1',
                null,
                renderPrice(ourPrice || 13.5, currency || 'USD')
              ),
              _react2.default.createElement(
                'p',
                { className: 'text--bold text--lg mv-' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'pricing-compare.classpass',
                  defaultMessage: 'ClassPass'
                })
              ),
              _react2.default.createElement(
                'p',
                { className: 'color-text-light' },
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                  id: 'pricing-compare.classpass-subtext',
                  defaultMessage: 'Price per class on a<br>10 class monthly membership'
                })
              )
            )
          )
        )
      );
    }
  }]);
  return ComparePricingUnwrapped;
}(_react.PureComponent);

ComparePricingUnwrapped.propTypes = {
  theirPrice: _propTypes2.default.number,
  ourPrice: _propTypes2.default.number,
  currency: _propTypes2.default.string,
  backgroundColor: _propTypes2.default.oneOf(['white', 'light'])
};

var ComparePricing = exports.ComparePricing = (0, _TrackDwell2.default)(ComparePricingUnwrapped);